const {keys} = Object;

export function isKeyOf<T extends object>(object: T, key: PropertyKey | null | undefined): key is keyof T {
    return !!key && key in object;
}

export function getKeys<T extends object>(object: T): Array<Extract<keyof T, string> | (string & {})> {
    return keys(object);
}

export function getKeysUnsafe<T extends object>(object: T) {
    return keys(object) as Array<Extract<keyof T, string>>;
}
